export default () => {
  return (
    <div>
      <p className="m-0">Tivemos um problema</p>
      <p className="h5 m-0">Alguma das opções não estão corretas:</p>
    </div>
  )
}
